module.exports = __webpack_public_path__ + "static/media/user.a6f0792d.svg";